import React, { useEffect, useRef } from 'react';
import './style.scss';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import vietinBankIcon from "assets/imgs/QrCodeMyVNPT/vietin-icon.png";
import vcbankIcon from "assets/imgs/QrCodeMyVNPT/vcbank-icon.png";
import agribankIcon from "assets/imgs/QrCodeMyVNPT/agribank-icon.png";
import bidvIcon from "assets/imgs/QrCodeMyVNPT/bidv-icon.png";
import myvnptBanner from "assets/imgs/QrCodeMyVNPT/myvnpt-banner.png";
import fireIcon from "assets/imgs/QrCodeMyVNPT/fire-icon.png";
import filterIcon from "assets/imgs/QrCodeMyVNPT/filter-icon.png";
import filterFillIcon from "assets/imgs/QrCodeMyVNPT/filter-filled.png";
import { SearchOutlined } from '@ant-design/icons';
import {Input, Modal, Skeleton} from 'antd';
import { useState } from 'react';
import QrCode from './QrCode/QrCode';
import Paying from './Paying/Paying';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import { QrCodeMyVNPTService } from './services/QrCodeMyVNPTService';
import { ACTION_IR_REGISTER, BANNER_PACKAGE_CODE } from './constant/contanst';
import {
  DETECT_DEEPLINK_PACKAGE_LIST_ENDPOINT,
  DETECT_PACKAGE_LIST_MILLISECOND,
  QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL,
  QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
} from 'global/environment';
import PackageItem from './component/PackageItem/PackageItem';
import giftHeader from "assets/imgs/QrCodeMyVnptVer2/gift-header.png";
import scanQrHeader from "assets/imgs/QrCodeMyVnptVer2/scanQr-header.png";
import BottomSheet from './component/ModalBottomSheet/ModalBottomSheet';
import PackageInfo from './component/PackageInfo/PackageInfo';
import FilterNational from './FilterNational/FilterNational';
import vourcherIcon from "assets/imgs/QrCodeMyVnptVer2/voucher-icon.png";
import FilterTimePrice from './FilterTimePrice/FilterTimePrice';
import closeIcon from "assets/imgs/QrCodeMyVNPT/close-icon.png";
import giftIcon from "assets/imgs/QrCodeMyVNPT/gift-icon.png";
import { cjmEventBlockClicked, cjmEventButtonClicked, cjmEventIconClicked, cjmEventItemSelected, cjmEventScreenDisplayed, cjmOnUserLogin } from 'utils/providers/cjmHelper';
import LoadingWithLogo from "./component/LoadingWithLogo/LoadingWithLogo";

const RoamingPackageMyVNPT = () => {
  const useQuery = () => new URLSearchParams(useLocation().search);
  const token = useQuery().get('token');
  const [activeTab, setActiveTab] = useState(0);
  const [countryId, setCountryId] = useState();
  const [countryName, setCountryName] = useState();
  const [listCountries, setListCountries] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isModalOTP, setIsModalOTP] = useState(false);
  const [step, setStep] = useState(0);
  // const [isModalInfo, setIsModalInfo] = useState(false);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [packageSelected, setPackageSelected] = useState();
  const [listPackage, setListPackage] = useState();
  const [rxServiceActive, setRxServiceActive] = useState();
  const [data, setData] = useState();
  const [dataTransactionParent, setDataTransactionParent] = useState();
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [timerOTP, setTimerOTP] = useState(0);
  const [isButtonRetry, setIsButtonRetry] = useState(true);
  const [imageSrcBannerMyVNPT, setImageSrcBannerMyVNPT] = useState("");
  const [isModalPackageInfo, setIsModalPackageInfo] = useState(false);
  const [packageInfo, setPackageInfo] = useState();
  const [listFavariteCountry, setListFavariteCountry] = useState([]);
  const [isModalFilterNational, setIsModalFilterNational] = useState(false);
  const [selectedCountries, setSelectedCountries] = useState(new Set());
  // const [tempSelectedCountries, setTempSelectedCountries] = useState(new Set(selectedCountries));
  const [isModalFilterTimePrice, setIsModalFilterTimePrice] = useState(false);
  const [selectedFilterTimePrice, setSelectedFilterTimePrice] = useState({ cycles: [], price: null });
  const [listCycle, setListCycle] = useState();
  const [loading, setLoading] = useState(false);
  const [percent, setPercent] = React.useState(0);
  const refFilterNational = useRef(null);
  const targetRef = useRef(null);
  const timeoutIdRef = useRef(null);

  const handleScrollRoaming = () => {
    console.log(targetRef);
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const mergedCountries = [
    ...new Map(
      [
        ...listCountries
        .filter(country => !listFavariteCountry.some(fav => fav.id === country.id))
        .filter(item => selectedCountries.has(item.id)), ...listFavariteCountry
      ]
      .map(item => [item.id, item])
    ).values()
  ];

  // const hotPromotion = packageSelected?.hotPromotion ? JSON.parse(packageSelected?.hotPromotion) : [];

  const filteredPackages = listPackage
  ?.filter(e => 
    (!selectedCountries.size || [...selectedCountries].every(id => e.nationalities.some(n => n.id === id))) &&
    (!selectedFilterTimePrice.cycles.length || selectedFilterTimePrice.cycles.some(cycle => 
      cycle === e.cycle
    ))
  )
  .sort((a, b) => {
    if (selectedFilterTimePrice.price === "asc") return a.price - b.price;
    if (selectedFilterTimePrice.price === "desc") return b.price - a.price;
    return 0;
  }) || [];

  const visiblePackages = showAll ? filteredPackages : filteredPackages.slice(0, 3);

  // useEffect(() => {
  //   getListBannerByType({
  //     type: 1,
  //     channel: 3,
  //     pageType: BANNER_PACKAGE_CODE.ROAMING_DIRECTAPP
  //   });
  // }, []);

  // useEffect(() => {
  //   if(localStorage.getItem('ldp_msisdn') && localStorage.getItem('ldp_token')) {
  //     cjmEventScreenDisplayed("myvnpt_web", "roaming_package_list", null)
  //   }
  // }, [localStorage.getItem('ldp_msisdn'), localStorage.getItem('ldp_token')]);

  useEffect(() => {
    localStorage.setItem('ldp_token', token);
    getPackageInfo({
      encryptedToken: token,
    })
  }, [token]);

  const initDataPackageList = (msisdn, session) => {
    setStep(0);
    getListBannerByType({
      type: 1,
      channel: 3,
      pageType: BANNER_PACKAGE_CODE.ROAMING_DIRECTAPP
    });

    getListNational({
      msisdn: msisdn,
      session: session
    });
  }

  useEffect(() => {
    let interval;
    if (timerOTP > 0 && isErrorModalVisible) {
      interval = setInterval(() => {
        setTimerOTP((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerOTP, isErrorModalVisible]);

  const getPackageInfo = async (payload) => {
    try {
      setLoading(isMobile());
      await QrCodeMyVNPTService.getPackageInfo(payload, res => {
        if (res?.errorCode === "0") {
          setData(res);
          setPackageSelected(res?.result?.packageDetail);
          setListFavariteCountry(res?.result?.listFavariteCountry.sort((a, b) => a.nameVn.localeCompare(b.nameVn)));
          setListCycle(res?.result?.listCycle?.sort((a, b) => a.cycleDuration - b.cycleDuration));
          localStorage.setItem('ldp_msisdn', res?.result?.msisdn);
          if (!res?.result?.packageDetail) {
            const valueStep = (100 / 5);
            let ptg = valueStep;
            setPercent(ptg);
            const timeoutInterval = DETECT_PACKAGE_LIST_MILLISECOND / 5;
            const interval = setInterval(() => {
              ptg += valueStep;
              setPercent(ptg);
              if (ptg >= 100) {
                clearInterval(interval);
                setLoading(false);
                setPercent(0);
              }
            }, timeoutInterval);

            setRxServiceActive(res?.result?.rxServiceActive);
            setListPackage(res?.result?.listPackage);

            const msisdn = res?.result?.msisdn;
            const session = res?.token;
            handleRedirect(msisdn, session);
          } else {
            setPercent(100);
            setTimeout(() => {
              setLoading(false);
            }, 300);
            setStep(1);
          }

          cjmOnUserLogin(res?.result?.msisdn, res?.result?.msisdn)
          setTimeout(() => {
            cjmEventScreenDisplayed("myvnpt_web", "roaming_package_list", null)
          }, 100);
        } else {

        }
      }, undefined, false);
    } catch (error) {
      console.log(error);
    }
  };

  const getListNational = async ({
    msisdn,
    session
  }) => {
    try {
      await QrCodeMyVNPTService.getListNational({
        msisdn: msisdn,
        session: session
      }, res => {
        if (res?.errorCode === "0") {
          let sortedCountries = res?.result.sort((a, b) => a.nameVn.localeCompare(b.nameVn));
          setListCountries(sortedCountries);
        }
      })
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) {
      setError("Bạn phải nhập OTP là dạng số");
      return;
    }
    if (value?.length > 6) return;
    setError("");
    setOtp(value);
  };

  const showErrorModal = (message) => {
    setError(message);
    setIsErrorModalVisible(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalVisible(false);
    setError('');
  };

  const handleRegister = async (item) => {
    setIsModalPackageInfo(false);
    setPackageSelected(item);
    cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "register_button")
    // const selectedCountryNames = listCountries
    // ?.filter(country => selectedCountries.has(country.id))
    // ?.map(country => country.nameVn).join(", ");
    setCountryName(listCountries.find(e => e.id == countryId)?.nameVn);

    if (data?.result?.irCheckActive === 0) {
      handleSendOTP(data?.result?.msisdn);
    } else if (data?.result?.irCheckActive === 1) {
      setStep(1);
    }
  };

  const handleSendOTP = (msisdn) => {
    let payload = {
      tinh_id: null,
      otp_service: "ir_register",
      msisdn
    };
    QrCodeMyVNPTService.sendOtp(payload, 
      (response) => {
        if (response.error_code === "0") {
          setIsModalOTP(true);
          setIsButtonRetry(true)
        } else if (response.error_code == "send_sms_nok") {
          showErrorModal(response.message)
          setIsButtonRetry(false)
          setTimerOTP(60);
        } else if (response.error_code == "send_sms_nok_limit_n") {
          showErrorModal(response.message)
          setIsButtonRetry(false)
          setTimerOTP(300);
        }
      }, 
      (error) => {
        setError("Có lỗi xảy ra khi gửi OTP.");
      }
    ); 
  };

  const handleOTP = () => {
    cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_confirm")
    if (otp?.length !== 6) return;
    const payload = {
      session: data?.token,
      otpValue: otp,
      msisdn: data?.result?.msisdn,
      action: ACTION_IR_REGISTER.ACTIVE
    }
    QrCodeMyVNPTService.irRegister(payload,
      (response) => {
        if (response?.errorCode === "0") {
          QrCodeMyVNPTService.getPackageInfo({
            encryptedToken: token,
          }, res => {
            if (res?.errorCode === "0") {
              setData(res);
              setStep(1);
              setOtp("")
            } 
          })
        } else if(response?.errorCode === "550") {
          showErrorModal(response?.message);
          setIsButtonRetry(true)
          setTimerOTP(0)
          setOtp("")
        } else if(response?.errorCode === "539") {
          showErrorModal(response?.message);
          setIsButtonRetry(false)
          setTimerOTP(0)
          setOtp("")
        } else if(response?.errorCode === "551" || response?.errorCode === "552") {
          showErrorModal(response?.message);
          setIsButtonRetry(false)
          setTimerOTP(300)
          setOtp("")
        } else {
          showErrorModal(response.message);
          setTimerOTP(0)
          setIsButtonRetry(true)
          setOtp("")
        }
      },
      (error) => {
        showErrorModal("Có lỗi xảy ra khi gọi API.");
        setIsButtonRetry(false)
        setOtp("")
      }
    );
    setIsModalOTP(false);
    setOtp("")
  };

  const convertImageToBase64 = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const handleResetFilterTimePrice = () => {
  };

  const handleConfirmFilterTimePrice = (filterData) => {
    setSelectedFilterTimePrice(filterData);
    setIsModalFilterTimePrice(false);
  };

  const getListBannerByType = async (payload) => {
    QrCodeMyVNPTService.getListBannerByType(payload, res => {
      if(res?.errorCode === '0' && res?.result[0]) {
        let banner = res?.rootImageUrl + res?.result
          ?.sort((a, b) => (a.position || 0) - (b.position || 0))
          ?.[0]?.imagePath;
        setImageSrcBannerMyVNPT(banner);
        // convertImageToBase64(banner).then((base64) => {
        //   setImageSrcBannerMyVNPT(base64);
        // });
      }
    }, err => {
      console.log(err);
    });
  };

  const clickTabMyVNPT = () => {
    setActiveTab(1)
    cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "my_vnpt_tab")
    if (!imageSrcBannerMyVNPT) {
      redirectToMyVNPT();
    } else {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
      timeoutIdRef.current = setTimeout(() => {
        redirectToMyVNPT();
      }, 1000);
    }
  }

  const onImageLoad = () => {
    redirectToMyVNPT();
  }

  const redirectToMyVNPT = () => {
    let deepLink =
    step === 0
    ? QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
    : `${QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL}&packageCode=${packageSelected?.packageCode}`
    window.location.href = deepLink;
  }

  const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log("device", userAgent);
    return !!(userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPod/i) ||
        userAgent.match(/Android/i));
  }

  const handleRedirect = (msisdn, session) => {
    let hostname = document.location.host
    if (!hostname) {
      hostname = "my.vnpt.com.vn"
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log("device", userAgent);

    const DEEP_LINK = "myvnpt://";
    if (
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPod/i)
    ) {
      let linkIOS = DEEP_LINK + DETECT_DEEPLINK_PACKAGE_LIST_ENDPOINT;
      openApp(linkIOS);
      setTimeout(() => {
        setLoading(false);
        console.log("START timeout IOS");
        if (document.hasFocus()) {
          console.log("IOS: Redirect LDP");
          initDataPackageList(msisdn, session);
        }
      }, DETECT_PACKAGE_LIST_MILLISECOND);
    } else if (userAgent.match(/Android/i)) {
      let linkAndDroid = DEEP_LINK + hostname + DETECT_DEEPLINK_PACKAGE_LIST_ENDPOINT
      openApp(linkAndDroid);
      setTimeout(() => {
        setLoading(false);
        console.log("START timeout Android");
        if (document.hasFocus()) {
          console.log("Android: Redirect LDP");
          initDataPackageList(msisdn, session);
        }
      }, DETECT_PACKAGE_LIST_MILLISECOND);
    } else {
      console.log("Not Android and IOS");
      setLoading(false);
      initDataPackageList(msisdn, session);
    }
  };

  const openApp = (link) => {
    window.location.replace(link);
  };

  return (
    <div id="roaming-package-myvnpt-v2">
      <Header />
      <LoadingWithLogo percent={percent} isLoading={loading}/>
      <div className="roaming-package__container">
        {step !== 2 && (
          <div className="roaming-package__tab">
            <div
              id="roaming-tab-qr"
              className={`roaming-package__tab--item ${activeTab === 0 ? "active" : ""}`}
              onClick={() => setActiveTab(0)}
            >
              <img src={scanQrHeader} alt="vourcherIcon" />
              <span>Chuyển khoản nhanh</span>
            </div>
            <a
              id="roaming-tab-myvnpt"
              className={`roaming-package__tab--item ${activeTab === 1 ? "active" : ""}`}
              // href={
              //   step === 0
              //   ? QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
              //   : `${QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL}&packageCode=${packageSelected?.packageCode}`
              // }
              onClick={clickTabMyVNPT}
            >
              {
                data?.result?.hasPromotion === 'YES' ? (
                  <div className="voucher-tab-myvnpt">
                    <img className="voucher-myvnpt-img" src={vourcherIcon} alt="voucher-icon" />
                    <span className="voucher-myvnpt-value">{data?.result?.cashbackPercentageValue}%</span>
                  </div>
                ) : (
                  <img className="voucher-myvnpt-img" src={giftIcon} alt="voucher-icon" />
                )
              }
              <span>My VNPT</span>
            </a>
          </div>
        )}

        {
          activeTab === 0 && (
            <>
              {
                step === 0 && (
                  <div>
                    {!loading && (<div className="roaming-package__content--title mx-16px">Chọn gói cước Quốc tế</div>)}
                    <div className="roaming-package__content">
                      <Skeleton active={true} loading={loading}>
                      <Input
                        className="qr-code__input-custom input-country"
                        placeholder="Tìm kiếm Quốc gia"
                        prefix={<SearchOutlined />}
                        suffix={
                          <img 
                            src={closeIcon} 
                            alt="close-icon" 
                            onClick={() => {
                              setSelectedCountries(new Set());
                              cjmEventIconClicked("myvnpt_web", "roaming_package_list", "country_clear")
                            }}
                          />
                        }
                        value={Array.from(selectedCountries)
                          .map(id => listCountries.find(country => country.id === id)?.nameVn)
                          .filter(Boolean) // Loại bỏ undefined nếu có
                          .join(", ")}
                        onClick={() => {
                          setIsModalFilterNational(true);
                          if (refFilterNational?.current) {
                            refFilterNational.current.updateTempSelectedCountries(new Set(selectedCountries));
                          }
                          cjmEventBlockClicked("myvnpt_web", "roaming_package_list", "input", "country_input")
                          // refFilterNational?.current.updateTempSelectedCountries(new Set(selectedCountries))
                          // setTempSelectedCountries(new Set(selectedCountries));
                        }}
                        readOnly
                      />
                      <div className="roaming-package--country">
                        <img src={fireIcon} alt="" />
                        <div className="roaming-package__content--country-tag">
                          {mergedCountries?.map((item, index) => (
                            <div
                              key={index}
                              // className={`country-tag-item ${item.id == countryId ? "active" : ""}`}
                              // onClick={() => setCountryId(prev => (prev === item.id ? null : item.id))}
                              className={`country-tag-item ${selectedCountries.has(item.id) ? "active" : ""}`}
                              onClick={() => {
                                setSelectedCountries((prev) => {
                                  const newSet = new Set(prev);
                                  newSet.has(item.id) ? newSet.delete(item.id) : newSet.add(item.id);
                                  return newSet;
                                });
                                cjmEventItemSelected("myvnpt_web", "roaming_package_list", 'DS quốc gia HOT', item.nameVn);
                              }}
                            >
                              {item.nameVn}
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="roaming-package__package--header">
                        <div className="roaming-package__package--title">Danh sách gói cước Quốc tế</div>
                        <div className="roaming-package__package--img" onClick={() => setIsModalFilterTimePrice(true)}>
                          <img src={(selectedFilterTimePrice?.cycles.length || selectedFilterTimePrice?.price) ? filterFillIcon : filterIcon} alt="" />
                        </div>
                      </div>
                      
                      <div className="roaming-package__package--list">
                        {visiblePackages?.length > 0 ? (
                          visiblePackages?.map((pkg, index) => (
                            <div key={index}>
                              <PackageItem
                                onClick={() => {
                                  setIsModalPackageInfo(true)
                                  setPackageInfo(pkg)
                                  cjmEventBlockClicked("myvnpt_web", "roaming_package_list", "block", "package_item")
                                }}
                                data={pkg}
                              />
                              {index < visiblePackages.length - 1 && <div className="divider-custom"></div>}
                            </div>
                          ))
                        ) : (
                          <div className="roaming-package__empty">Không tìm thấy gói cước thoả mãn điều kiện</div>
                        )}
                      </div>
                      {filteredPackages?.length > 3 && (
                        <div className="roaming-package__content--see-more" onClick={() => {
                          setShowAll(!showAll);
                          if(!showAll) {
                            cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "load_more")
                          }
                        }}>
                          {showAll ? "Thu gọn" : "Xem thêm"}
                        </div>
                      )}
                      <div className="roaming-package__content--footer">
                        <div className="roaming-package__content--footer-txt">Thanh toán qua QR với tất cả ngân hàng và ví</div>
                        <div className="roaming-package__content--footer-bank">
                          <img src={vcbankIcon} alt="vcbankIcon" />
                          <img src={agribankIcon} alt="momoIcon" />
                          <img src={bidvIcon} alt="zalopayIcon" />
                          <img src={vietinBankIcon} alt="vietinBankIcon" />
                          <span>+36</span>
                        </div>
                      </div>
                      </Skeleton>
                    </div>
                  </div>
                )
              }
              {step === 1 && 
                <QrCode
                  token={token}
                  setStep={setStep}
                  data={data}
                  setData={setData}
                  packageSelected={packageSelected}
                  countryName={countryName}
                  setDataTransactionParent={setDataTransactionParent}
                />
              }
              {step === 2 && <Paying data={data} dataTransaction={dataTransactionParent} token={token}/>}
            </>
          )
        }

        {
          activeTab === 1 && (
            <div className="roaming-package__content roaming-package__tab-myvnpt">
              <div className="roaming-package__content--title mx-16px">Đang điều hướng sang ứng dụng My VNPT</div>
              {/* {
                (step === 1 && packageSelected && dataTransactionParent) &&
                <div className="qr-code__info">
                  <div className="qr-code__info-detail">
                    <div className="qr-code__info--item">
                      <div className="info-txt-normal">Gói cước</div>
                      <div className="info-txt-bold">{packageSelected?.packageName}</div>
                    </div>
                    {
                      countryName 
                      ? 
                      <div className="qr-code__info--item">
                        <div className="info-txt-normal">Quốc gia</div>
                        <div className="info-txt-bold">{countryName}</div>
                      </div> 
                      : 
                      <></>
                    }
                    {
                      hotPromotion?.map((e, i) => (
                        <div key={i} className="qr-code__info--item">
                          <div className="info-txt-normal">{e.key}</div>
                          <div className="info-txt-bold">{e.value}</div>
                        </div>
                      ))
                    }
                  </div>
                  {
                    dataTransactionParent && (
                      <div className="qr-code__info--icon" onClick={() => setIsModalInfo(true)}>
                        <img src={dropDownIcon} alt="" />
                      </div>
                    )
                  }
                </div>
              } */}

              {
                imageSrcBannerMyVNPT && (
                  <a
                    href={
                      step === 0
                      ? QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
                      : `${QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL}&packageCode=${packageSelected?.packageCode}`
                    }
                  >
                    <div className="qr-code-myvnpt__img">
                      <img src={imageSrcBannerMyVNPT} alt="myvnpt-banner" onLoad={onImageLoad}/>
                    </div>
                  </a>
                )
              }

              <div className="qr-code-myvnpt__guide-txt">Để quay trở lại ứng dụng My VNPT, vui lòng<br />
                <a
                  className="qr-code__vourcher-used"
                  href={
                    step === 0 
                    ? QR_CODE_MYVNPT_DEEPLINK_PACKAGE_LIST
                    : `${QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL}&packageCode=${packageSelected?.packageCode}`
                  }
                >
                  Nhấn vào đây
                </a>
              </div>
            </div>
          )
        }
        <Footer />
      </div>
      {/* dataTransaction={dataTransaction} */}
      {/* <PaymentInfo
        countryName={countryName}
        packageSelected={packageSelected}
        msisdn={data?.result?.msisdn}
        isModal={isModalInfo}
        setIsModal={setIsModalInfo}
        dataTransaction={dataTransactionParent}
      /> */}
      
      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        closable={null}
        open={isModalOTP}
        maskClosable={false}
        onOk={() => setIsModalOTP(true)}
        onCancel={() => setIsModalOTP(false)}
      >
        <div className="roaming-package-modal-otp">
          <div className="modal-otp-title">Bật chuyển vùng dữ liệu</div>
          <div className="modal-otp-txt">
            Để đăng ký, quý khách cần bật chuyển vùng dữ liệu. Vui lòng nhập OTP được gửi đến số điện thoại
            <span> {data?.result?.msisdn ? (data?.result?.msisdn.slice(0, 2) === '84' ? `0${data?.result?.msisdn?.slice(2)}` : data?.result?.msisdn) : ''} </span>
            để bật chuyển vùng
          </div>
          <div className="modal-otp-txt">Lưu ý: Quý khách cần tắt chuyển vùng dữ liệu nếu không còn muốn đăng ký</div>
          <div>
            <Input
              className="modal-otp-input qr-code__input-custom"
              placeholder="Nhập mã OTP"
              value={otp}
              onChange={handleChange}
              maxLength={6}
              type="number"
            />
            {error && <div className="error-message">{error}</div>}
          </div>
          <button
            className="qr-code__btn-custom"
            onClick={handleOTP}
            disabled={otp?.length !== 6}
          >
            Tiếp tục
          </button>
        </div>
      </Modal>

      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        maskClosable={false}
        closable={null}
        open={isErrorModalVisible}
        onCancel={() => closeErrorModal()}
      >
        <div className="roaming-package-modal-otp">
          <div className="modal-otp-title">Thông báo</div>
          <div className="modal-otp-txt">
            {error}
          </div>
          <div className='group-btn'>
            {
              isButtonRetry && <button
                className="qr-code__btn-custom normal"
                key="retry"
                onClick={() => {
                  closeErrorModal();
                  setIsModalOTP(true)
                  cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_cancel")
                }}
              >
                Nhập lại
              </button>
            }
            <button
              key="resendOtp"
              onClick={() => {
                closeErrorModal();
                handleSendOTP(data?.result?.msisdn);
                cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_resend")
              }}
              className={`qr-code__btn-custom`}
              disabled={timerOTP > 0}
            >
              Gửi lại OTP{' '}
              {timerOTP > 0 && <span id="timer"> ({timerOTP}s)</span>}
            </button>
          </div>
        </div>
      </Modal>

      <BottomSheet
        isVisible={isModalPackageInfo}
        onClose={() => {
          setIsModalPackageInfo(false)
          setPackageInfo(null)
        }}
        action1Text="Trở lại"
        action2Text={packageInfo?.packageCode == rxServiceActive ? "Đã đăng ký" : "Đăng ký"}
        action2IsDisabled={packageInfo?.packageCode == rxServiceActive}
        onAction1={() => setIsModalPackageInfo(false)}
        onAction2={() => handleRegister(packageInfo)}
      >
        <PackageInfo data={packageInfo}/>
      </BottomSheet>

      <BottomSheet
        isVisible={isModalFilterNational}
        onClose={() => {
          setIsModalFilterNational(false)
          cjmEventIconClicked("myvnpt_web", "roaming_package_list", "country_close")
        }}
        action1Text="Xóa chọn"
        action2Text="Xác nhận"
        // onAction1={() => setTempSelectedCountries(new Set())}
        onAction1={()=>  {
          if(refFilterNational?.current){
            refFilterNational.current.resetTempSelectedCountries()
          }
          cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "country_back")
        }}
        onAction2={() => {
          if(refFilterNational?.current){
            const con = refFilterNational.current.getTempSelectedCountries()
            setSelectedCountries(new Set(con));
            setIsModalFilterNational(false);
          }
          cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "country_confirm")
        }}
        // className="filter-national"
      >
        <FilterNational
          ref={refFilterNational}
          listCountries={listCountries}
          // tempSelectedCountries={tempSelectedCountries}
          // setTempSelectedCountries={setTempSelectedCountries}
          // onScroll={handleScrollRoaming}
        />
      </BottomSheet>

      <BottomSheet
        isVisible={isModalFilterTimePrice}
        onClose={() => setIsModalFilterTimePrice(false)}
        className="filter-time-price"
      >
        <FilterTimePrice
          key={Date.now()}
          listCycle={listCycle}
          onReset={handleResetFilterTimePrice}
          onConfirm={handleConfirmFilterTimePrice}
          initialFilter={selectedFilterTimePrice}
        />
      </BottomSheet>
    </div >
  );
}

export default React.memo(RoamingPackageMyVNPT);
